import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function Interlude() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y1 = useTransform(scrollYProgress, [0, 1], [-40, 40]);
  const y2 = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section
      ref={ref}
      data-testid="interlude-section"
      className="relative py-28 md:py-40 px-6 md:px-12 bg-ink text-white overflow-hidden"
    >
      <motion.div
        style={{ y: y1 }}
        className="absolute -bottom-20 -left-20 w-80 h-80 bg-orange rounded-full opacity-15 blur-3xl pointer-events-none"
      />
      <motion.div
        style={{ y: y2 }}
        className="absolute -top-20 -right-20 w-80 h-80 bg-blue rounded-full opacity-15 blur-3xl pointer-events-none"
      />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <motion.span
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3 }}
          className="section-num text-orange mb-10 inline-flex"
        >
          ✦ Pausa
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, delay: 0.05 }}
          className="font-display text-5xl md:text-7xl lg:text-8xl text-white leading-[1.02]"
        >
          Dizer não <span className="brush-underline brush-underline-orange">ao medo</span>
          <br />
          <span className="font-serif-display text-orange normal-case lowercase">começa aqui.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, delay: 0.12 }}
          className="font-serif-display text-xl md:text-3xl text-white/80 max-w-2xl mx-auto mt-10 leading-snug"
        >
          O que queres é maior do que o que temes.
        </motion.p>
      </div>
    </section>
  );
}
